<template>
    <div>
      <vs-prompt
      @cancel="Canceld"
      @accept="Accepted"
      @close="Closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddObjectDebitorRoom"
      :is-valid="formValid">
       <div>
        <div>
          <p>{{$t('ADD_DEBITOROBJECT_ROOM.HEADER.TEXT')}}</p>
          <vs-divider>{{$t('ADD_DEBITOROBJECT_ROOM.DIVIDER.NAME')}}</vs-divider>
          <div class="default-input clearfix align-items-center mb-3">
            <vs-input :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.NAME')"  class="float-left mr-2 inputx" :placeholder="$t('ADD_DEBITOROBJECT_ROOM.LABEL.PLACEHOLDER.NAME')"  v-model="name"  :danger="name_fail" val-icon-danger="clear" />                           
          </div>
          <vs-divider>{{$t('ADD_DEBITOROBJECT_ROOM.DIVIDER.MASSE')}}</vs-divider>
          <div class="default-input d-flex align-items-center mb-3">
            <vs-input-number v-model="length" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.LENGTH')" step="0.5" class="inputx mr-2" :class="length_fail ? 'input_number_invalid':''"/>
            <vs-input-number v-model="width" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.WIDTH')" step="0.5" class="inputx mr-2" :class="width_fail ? 'input_number_invalid':''"/>
            <vs-input-number v-model="height" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.HEIGHT')" class="inputx mr-3"  :class="height_fail ? 'input_number_invalid':''"/>
          </div>
          <div class="default-input d-flex align-items-center mb-3">
            <vs-input-number v-model="flaeche" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.FLAECHE')" step="0.5" class="inputx mr-2" :class="flaeche_fail ? 'input_number_invalid':''"/>
            <vs-input-number v-model="volume" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.VOL')"  class="inputx mr-2" />
            <vs-tooltip :text="$t('ADD_DEBITOROBJECT_ROOM.TOOLTIP.CALC_VOL')">
              <vs-button  size="small" color="primary" type="filled" icon="functions" class="ml-2" @click="CalcVolume()"></vs-button>
            </vs-tooltip>
          </div>          
          <vs-divider>{{$t('ADD_DEBITOROBJECT_ROOM.DIVIDER.WNDOWS_WALLS')}}</vs-divider>
          <div class="default-input clearfix align-items-center mb-3">
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.AUSSENW')" :type="ROOMAUSSEN" v-model="aussenwand"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.DECKE')" :type="ROOMDECKE" v-model="decke"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.BODEN')" :type="ROOMBODEN" v-model="boden"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.FENSTER')" :type="ROOMFENSTER" v-model="fenster"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.INNENW')" :type="ROOMINNEN" v-model="innenwaende"></InputSelectList>
            </div>
          </div>
          <vs-textarea height="200px" counter="500" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.BESCHREIBUNG')" :counter-danger.sync="description_fail" v-model="description" />
        </div>
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import InputSelectList from '../InputSelectList.vue';
import {inputSelectType} from '../../../helper/enumHelper';

export default {
  name: "AddDebitorObjectRoomDlg",
  props:['InitData'],
  components:{
    InputSelectList
  },
  data: function (){
     return {
      dlgActive: false,
      popupTitle: this.$t('ADD_DEBITOROBJECT_ROOM.TITLE'),
      id:0,
      name:"",
      description:"",
      length:0, 
      width:0, 
      flaeche:0,
      debitorobject_fk:0,
      height:0,
      volume:0, 
      aussenwand:"", 
      decke:"", 
      boden:"", 
      fenster:"", 
      innenwaende:"",
      description_fail:false,
      name_ok:false,
      name_fail:false,
      length_fail:false,
      length_ok:false,
      width_fail:false,
      width_ok:false,
      flaeche_fail:false,
      flaeche_ok:false,
      height_fail:false,
      height_ok:false,
      volume_fail:false,
      volume_ok:false,
      ROOMAUSSEN: inputSelectType.ROOMAUSSEN,
      ROOMDECKE: inputSelectType.ROOMDECKE,
      ROOMBODEN: inputSelectType.ROOMBODEN,
      ROOMFENSTER: inputSelectType.ROOMFENSTER,
      ROOMINNEN: inputSelectType.ROOMINNEN
     }
  }, 
  mounted () {
    this.ClearForm();
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ShowDlg(id){
        this.ClearForm();
        this.debitorobject_fk = id;
        this.dlgActive = true;
      },
      Closed(){
        this.ClearForm();
      },
      InitDlgData(data){
        
        if(this.IsNotNull(data))
        {
          this.popupTitle = this.$t('ADD_DEBITOROBJECT_ROOM.TITLE.EDIT');
          this.id = data.id;
          this.name = data.name;
          this.description = data.description;
          this.width = data.width;
          this.length = data.length;
          this.flaeche = data.flaeche;
          this.debitorobject_fk = data.debitorobject_fk;
          this.height = data.height;
          this.volume = data.volume; 
          this.aussenwand = data.aussenwand; 
          this.decke = data.decke; 
          this.boden = data.boden; 
          this.fenster = data.fenster; 
          this.innenwaende = data.innenwaende;
          
          this.dlgActive=true;
        }
      },
      Accepted(){

         var name = this.name;

          var data = {
            id: this.id,
            name: this.name,
            description: this.description,
            length: Number(this.length), 
            width: Number(this.width), 
            flaeche: Number(this.flaeche),
            debitorobject_fk: this.debitorobject_fk,
            height: Number(this.height),
            volume: Number(this.volume), 
            aussenwand: this.aussenwand, 
            decke: this.decke, 
            boden: this.boden, 
            fenster: this.fenster, 
            innenwaende: this.innenwaende
          };

          this.$store.dispatch('debitorobject/saveDebitorObjectRoom', data)
          .then(response => {
            if(response.success === true)
            {
                this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('ADD_DEBITOROBJECT_ROOM.SUCCESS.SAVE').replace("*1*",name)});  
            }
            else
            {
              var text = this.$t('ADD_DEBITOROBJECT_ROOM.WARNING.SAVE').replace("*1*",name);
              text = text.replace("*2*",this.$t(response.text));
              this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
            }
            this.$emit('Accepted');
          }, 
          error =>{
              var text = this.$t('ADD_DEBITOROBJECT_ROOM.ERROR.SAVE').replace("*1*",name);
              text = text.replace("*2*",error);
              this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':text});  
              this.$emit('Accepted');
          });
          
          this.ClearForm();
      },
      Canceld(){
        this.ClearForm();
      },
      ClearForm(){
       
        this.popupTitle = this.$t('ADD_DEBITOROBJECT_ROOM.TITLE');

        this.id = 0;
        this.name = "";
        this.description = "";
        this.width = 0; 
        this.length = 0;
        this.flaeche = 0;
        this.debitorobject_fk = 0;
        this.height = 0;
        this.volume = 0; 
        this.aussenwand = ""; 
        this.decke = ""; 
        this.boden = ""; 
        this.fenster = ""; 
        this.innenwaende = "";
        this.name_ok = false;
        this.name_fail=false;
        this.length_fail=false;
        this.length_ok=false;
        this.width_fail =false;
        this.width_ok = false;
        this.flaeche_fail=false;
        this.flaeche_ok=false;
        this.height_fail = false;
        this.height_ok = false;
        this.volume_fail = false;
        this.volume_ok = false;
      },
      CalcVolume(){
        // Zuerst Fläche berechnen, wenn möglich
        if(Number(this.length) > 0 && Number(this.width) > 0){
          this.flaeche = Number(Number(this.length) * Number(this.width)).toFixed(2);
        }
        
        // Dann Volumen berechnen, wenn möglich
        if(Number(this.flaeche) > 0 && Number(this.height) > 0){
          this.volume = Number(Number(this.flaeche) * Number(this.height)).toFixed(2);
        }
      }
  },
  computed:{
    formValid(){
        // Name muss vorhanden sein
        if(!this.name_ok) return false;
        
        // Mindestens 2 von 3 Werten (length, width, flaeche) müssen vorhanden sein
        var filledCount = 0;
        if(Number(this.length) > 0) filledCount++;
        if(Number(this.width) > 0) filledCount++;
        if(Number(this.flaeche) > 0) filledCount++;
        
        return filledCount >= 2;
    }
  },
  watch:{
    length(value){
      if(value < 0)
      {
        this.length = 0;
      }

      // Validierung: Länge ist nur dann ein Problem wenn weniger als 2 Werte vorhanden sind
      var filledCount = 0;
      if(Number(value) > 0) filledCount++;
      if(Number(this.width) > 0) filledCount++;
      if(Number(this.flaeche) > 0) filledCount++;
      
      this.length_fail = filledCount < 2;
      this.length_ok = !this.length_fail;
    },
    width(value){
      if(value < 0)
      {
        this.width = 0;
      }

      // Validierung: Breite ist nur dann ein Problem wenn weniger als 2 Werte vorhanden sind
      var filledCount = 0;
      if(Number(this.length) > 0) filledCount++;
      if(Number(value) > 0) filledCount++;
      if(Number(this.flaeche) > 0) filledCount++;
      
      this.width_fail = filledCount < 2;
      this.width_ok = !this.width_fail;
    },
    flaeche(value){
      if(value < 0){
        this.flaeche = 0;
      }
      
      // Validierung: Fläche ist nur dann ein Problem wenn weniger als 2 Werte vorhanden sind
      var filledCount = 0;
      if(Number(this.length) > 0) filledCount++;
      if(Number(this.width) > 0) filledCount++;
      if(Number(value) > 0) filledCount++;
      
      this.flaeche_fail = filledCount < 2;
      this.flaeche_ok = !this.flaeche_fail;
    },
    height(value){
      if(value < 0)
      {
        this.height = 0;
      }

      // Höhe ist optional
      this.height_fail = false;
      this.height_ok = value > 0;
    },
    volume(value){
      if(value < 0)
      {
        this.volume = 0;
      }

      // Volumen ist optional
      this.volume_fail = false;
      this.volume_ok = value > 0;
    },
    name(value)
    {
      this.name_fail = value.length == 0;
      this.name_ok = !this.name_fail;
    }
  }
};
</script>
<style>
div#promptAddObjectDebitorRoom > div.vs-dialog{
  max-width: 800px !important;
}
</style>